export enum EDomIds {
  HEADER = 'header',
  MODAL_MAP_SIDEBAR = 'sidebar',
  MODAL_SEARCH_LOCATION = 'modal-search-location',
  SIMULATION_PROGRESS_MODAL = 'simulation-progress-modal',
  MODAL_RUN_SIMULATION_CTA = 'modal-run-simulation-cta',
}
